import React from "react";
import { Grid } from "@material-ui/core";
import { BasketItem } from "../../../models/BasketItem";
import { useTranslation } from "react-i18next";
import EAButton from "../../shared/Buttons/EAButton";

interface IProps {
  reservationName: string;
  reservationDate: string;
  qnt: number;
  lines: BasketItem[];
  clearReservation: () => void;
  saveReservation: () => void;
}

const EndStep: React.FC<IProps> = ({
  reservationName,
  reservationDate,
  qnt,
  lines,
  clearReservation,
  saveReservation,
}: IProps) => {
  const { t } = useTranslation();
  const totalLines = () => lines.reduce((acc: number, item: BasketItem) => acc + item.price * item.qnt, 0);

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} className={"summary-info-warning"}>
        <div className="alert alert-yellow">{t("po_rezerwacji_nasi_konsultanci_przeanalizuja_twoje_zamowienie")}</div>
      </Grid>
      <Grid item xs={6} className={"summary-info"}>
        <div className="flex-start-center">
          <b>{t("rezerwacja")}:</b>
          <span>{reservationName}</span>
        </div>

        <div className="flex-start-center">
          <b>{t("termin")}:</b>
          <span>{reservationDate}</span>
        </div>

        <div className="flex-start-center">
          <b>{t("ilosc_osob")}:</b>
          <span>{qnt}</span>
        </div>
      </Grid>
      <Grid item xs={6} className={"summary-lines"}>
        <b>{t("twoje_zamowienie")}</b>

        <div className="summary-header flex-between-center ">
          <b>{t("nazwa")}</b>
          <span>{t("ilosc")}</span>
          <span>{t("cena")}</span>
        </div>

        {lines.map((item: BasketItem, index: number) => (
          <div className="summary-line flex-between-center" key={index}>
            <b>{item.assortName}</b>
            <span>{item.qnt}</span>
            <span>
              {item.price} {t("zl")}
            </span>
          </div>
        ))}
      </Grid>
      <Grid item xs={12} className={"summary-lines-total"}>
        <p>
          {t("do_zaplaty")}:{" "}
          <span>
            {" "}
            {totalLines()} {t("zl")}
          </span>
        </p>
      </Grid>
      <Grid item xs={12} className={"summary-buttons"}>
        <EAButton title={t("zatwierdz_rezerwacje")} onClick={() => saveReservation()} fullWidth />
        <EAButton title={t("zacznij_od_nowa")} onClick={() => clearReservation()} variant="text" fullWidth />
      </Grid>
    </Grid>
  );
};

export default EndStep;
